<script>
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import LinkPicker from "../../Common/LinkPicker.svelte";
  import BlockGlobal from "./BlockGlobal.svelte";
  import { getCollapseClass } from "../../Common/tools";
  import {External, M} from "../../external";

  export let data,
    disable = [],
    isCollapsable = false,
    isCollapsed = false;

  let textSizeSlider, fontWeightSlider;

  function onLinkChange(result) {
    data = Object.assign({}, data, { link: result.link });
  }

  function toggleCollapse() {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
    }
  }

  $: if (!data.buttonStyle) data.buttonStyle = {};

  $: if(! isCollapsed) {
    External.Tools.addSlider({
      min: 1,
      max: 72,
      step: 1,
      value: data.buttonStyle.fontSize,
      updatedViewSuffix: 'px',
      element: External.$(textSizeSlider),
      onChange: function (val) {
        data.buttonStyle.fontSize = val;
      }
    });

    External.Tools.addSlider({
      min: 400,
      max: 700,
      step: 100,
      value: data.buttonStyle.fontWeight,
      element: External.$(fontWeightSlider),
      onChange: function (val) {
        data.buttonStyle.fontWeight = val;
      }
    });
  }
</script>

<div class="col20 f-left t-center mt-15" on:click={toggleCollapse}><h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{M.BUTTON}</h4></div>
{#if !isCollapsed}
  <div class="section">
    <div class="right-side none">
      <input bind:value={data.text} type="text" class="transition-border" />
    </div>
    <div class="right-side">
      <LinkPicker config={data} onComplete={onLinkChange} emailLinkPicker={true} />
    </div>
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker bind:color={data.buttonStyle.backgroundColor} label={M.BUTTON_BACKGROUND_COLOR} alpha="no" />
    </div>
    {#if disable.indexOf("align") === -1}
      <div class="popup-input-wrapper input-slider-wrapper mt-5">
        <h5 class="inline">{M.ALIGNMENT}</h5>
        <select bind:value={data.buttonStyle.position}>
          <option value="left">{M.LEFT}</option>
          <option value="center">{M.CENTER}</option>
          <option value="right">{M.RIGHT}</option>
        </select>
      </div>
    {/if}
    <div class="popup-input-wrapper">
      <h5 class="inline">{M.TEXT_FONT_FAMILY}</h5>
      <select bind:value={data.buttonStyle.fontFamily}>
        {#each External.GlobalStyling.getAvailableFontNames() as font}
          <option value={font}>{font}</option>
        {/each}
      </select>
    </div>
    <div class="popup-input-wrapper input-slider-wrapper">
      <h5 class="inline">{M.FONT_SIZE}</h5>
      <div bind:this={textSizeSlider}></div>
      <input type="text" readonly="readonly" class="slider-val">
    </div>
    <div class="popup-input-wrapper input-slider-wrapper">
      <h5 class="inline">{M.FONT_WEIGHT}</h5>
      <div bind:this={fontWeightSlider}></div>
      <input type="text" readonly="readonly" class="slider-val">
    </div>
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker bind:color={data.buttonStyle.color} label={M.FONT_COLOR} alpha="no" />
    </div>
  </div>
{/if}
<BlockGlobal bind:data disable={disable} isCollapsable={true} isCollapsed={true} />
